import { configureStore } from '@reduxjs/toolkit';
import municipalitiesReducer from './reducers/MunicipalitiesReducer';
import citiesReducer from './reducers/CitiesReducer';
import schoolsReducer from './reducers/SchoolsReducer';
import schoolTypesReducer from './reducers/SchoolTypesReducer';
import teachersReducer from './reducers/TeachersReducer';
import studentsReducer from './reducers/StudentsReducer';
import gradesReducer from './reducers/GradesReducer';
import studentsResultsReducer from './reducers/StudentsResultsReducer';

const store = configureStore({
  reducer: {
    municipalities: municipalitiesReducer,
    cities: citiesReducer,
    schools: schoolsReducer,
    schoolTypes: schoolTypesReducer,
    teachers: teachersReducer,
    students: studentsReducer,
    grades: gradesReducer,
    studentsResults: studentsResultsReducer,
  },
});

export default store;
